module.exports = __webpack_public_path__ + "img/wk4.b2ccf89a.png";